import { Component, OnInit } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductOrderService } from '../../services/point-store-product-order.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { NgbCarouselConfig, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CvNumberLocalizePipe } from '../../../../../reusables/pipes/cv-number-localize.pipe';

@Component({
    selector: 'cv-shopping-cart-landing',
    templateUrl: './shopping-cart-landing.component.html',
    providers: [NgbCarouselConfig],
    styleUrls: ['./shopping-cart-landing.component.scss']
})
export class ShoppingCartLandingComponent implements OnInit {

    active: number = 0;
    pscs = null;
    pspos = null;
    productQuantity: number = 1;
    selectedVariation = null;
    initialVariationPrice = null;
    saleVariationFlag: boolean = false;
    highlightCartItem: boolean = false;
    sliderEventHandlerCount: number = 0;
    isVariationSelected: boolean = true;
    homSlideImgIndex: number = 0;
    homeSliderProductImages = [];
    HomeProductSliderInitialized: boolean = false;
    currentFilter: string = '';
    marketplaceProductSections = {
        Home: 1,
        Products: 2,
        BestSellers: 3,
        Wishlist: 4,
        Orders: 5,
        ProductsCategory: 6,
        ProductsSubcategory: 7
    };
    previousSection = null;
    _localizationStrings = new Map();
    notificationClickedHandler = null;

    maxHeight: number = 0;
    priceFilterChecked: any = [];
    subCategoriesFilterChecked: any = [];
    selected = "PriceLowToHigh";
    expanded = [];
    filterMatchProduct = '';
    sortBy = 'CalculatedRealPrice';
    filterBy = [
        { kind: 'price', chk: false, val: null },
        { kind: 'sale', chk: false, val: null },
        { kind: 'category', chk: true, val: 'All' },
        { kind: 'subcategory', chk: false, val: null },
        { kind: 'wishlist', chk: false, val: null },
        { kind: 'bestSeller', chk: false, val: null }];
    lastAdded = null;
    filterargs = { Active: true };
    attributeList = []
    drawerTimeOut = null;
    allowedQuantity: number = 20;

    selectedVariationObj = null;
    carouselIndex: number = 0;
    previousSelectedQty: number = 1;

    constructor(
        private cvNumberLocalize: CvNumberLocalizePipe,
        private pointStoreProductOrderService: PointStoreProductOrderService,
        private shoppingCartService: ShoppingCartService,
        private cvLocalizationService: CVLocalizationService,
        private modalService: NgbModal,
        config: NgbCarouselConfig,
        private dialogService: CvCustomDialogService,
        private cvConfigurationService: CvConfigurationService
    ) {
        this.pspos = pointStoreProductOrderService.pointStoreProductOrderObj;
        this.pscs = shoppingCartService.shoppingCartObj;
        config.interval = 6000;
        config.pauseOnHover = true;
    }

    // improve loading services
    async open(content) {
        this.modalService.open(content, { windowClass: 'cv-marketplace-window', modalDialogClass: 'cv-modal-full', centered: true });
        this.pscs.shoppingCartShowLoader = true;
        this.pscs.pointStoreVisibleContent.showShoppingCartPage = false;
        this.loadLocalizations();
        await this.shoppingCartService.getAttributesInfo();
        await this.shoppingCartService.getUserLoginProfile();
        await this.shoppingCartService.getLandingInfo();
        await this.shoppingCartService.getSessionCart();
        await this.shoppingCartService.getFullLogin();
        this.shoppingCartService.getCarouselItems();

        // Cart drawer: 
        window.dispatchEvent(new Event('resize'));
        window.addEventListener('resize', (event) => {
            let nonparent = $('#store-cart-icon');
            let position = nonparent.offset();
            let drawerWidth = document.getElementById('cart-drawer').offsetWidth;
            let drawerRectangleWidth = document.getElementById('drawer-cart-icon').offsetWidth;
            $('#cart-drawer').offset({
                left: (position.left - drawerWidth) + drawerRectangleWidth
            });
            $('#drawer-cart-icon').offset({
                left: position.left
            });
        }, true);

        //Hide cart drawer
        $(document).click((event) => {
            let drawerElment = document.getElementById('cart-drawer');
            let $target = $(event.target);
            if (!$target.closest('#cart-drawer').length && !$target.parents('.drawer-delete-btn').length && drawerElment?.style.opacity == "1") {
                this.pscs.pointStoreVisibleContent.showPopUpAddedCart = false;
                this.highlightCartItem = false;
                this.setCartDrawerVisible();
                if (this.drawerTimeOut != null)
                    clearTimeout(this.drawerTimeOut);
            }
        });
        this.goToHome();
        this.setSlider();
        this.setHomeSlider();
        this.pscs.shoppingCartShowLoader = false;
    }

    ngOnInit(): void { }

    //Slider handler
    onSlide(event) {
        let currIndex = parseInt(event.current.replace("slideId_", ""), 10);
        let prevIndex = parseInt(event.prev.replace("slideId_", ""), 10);
        if (this.pscs.pointStoreProductCarouselItems.length > 0 && this.HomeProductSliderInitialized) {
            this.homSlideImgIndex = 0;
            this.carouselIndex = currIndex;
            this.homeSliderProductImages = [];
            let featuredImages: any = document.getElementsByClassName('featured-home');
            if (this.pscs.pointStoreProductCarouselItems[currIndex].HasMultipleImages && this.pscs.pointStoreProductCarouselItems[currIndex].MultipleImagesData.length > 0) {
                this.pscs.pointStoreProductCarouselItems[currIndex].MultipleImagesData.forEach((image, index) => {
                    if (index == 0)
                        this.homeSliderProductImages.push({ active: true, source: '../Admin/ImageResizer.aspx?imgid=' + image.PointStoreProductImageID + '&w=auto&h=388' });
                    else
                        this.homeSliderProductImages.push({ active: false, source: '../Admin/ImageResizer.aspx?imgid=' + image.PointStoreProductImageID + '&w=auto&h=388' });
                });
                if (featuredImages.length > 1) {
                    for (var i = 0; i < featuredImages.length; i++) {
                        featuredImages[i].src = this.homeSliderProductImages[0].source;
                    }
                } else {
                    featuredImages.src = this.homeSliderProductImages[0].source;
                }
            }
        }
        //Reset product qty on slide change.
        if (Number.isFinite(currIndex) && currIndex !== prevIndex && this.pscs.pointStoreVisibleContent.showProductSectionLanding) {
            this.productQuantity = 1;
            this.previousSelectedQty = this.productQuantity;
            this.isVariationSelected = true;
            this.selectedVariation = null;
        }
    }

    loadLocalizations() {
        this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
            this._localizationStrings = map;
        });
    }

    /**
        * Returns the localization for the provided Key, or defaultValue if missing.
        * @param key String's Key from the *.Language Section for this module
        * @param defaultValue String returned if localizations didn't load, or the key is missing.
        */
    getLocalizationString(key, defaultValue) {
        if (this._localizationStrings && this._localizationStrings.has(key))
            return this._localizationStrings.get(key);
        return defaultValue;
    }

    setCartDrawerVisible() {
        let drawerWidth = document.getElementById('cart-drawer');
        let drawerRectangleWidth = document.getElementById('drawer-cart-icon');
        if (this.pscs.pointStoreVisibleContent.showPopUpAddedCart) {
            drawerWidth.style.opacity = "1";
            drawerWidth.style.zIndex = "100";
            drawerRectangleWidth.style.display = '';
            drawerRectangleWidth.style.opacity = "1";
        } else {
            drawerWidth.style.opacity = "0";
            drawerWidth.style.zIndex = "0";
            drawerRectangleWidth.style.display = 'none';
            drawerRectangleWidth.style.opacity = "0";
        }
    }

    goToHome() {
        this.cleanInput();
        $(".linee").show();
        this.previousSection = this.marketplaceProductSections.Home;
        this.productQuantity = 1;
        this.isVariationSelected = true;
        this.selectedVariation = null;
        this.setVisibleSections(false, false, true, true, false, false, false, false, false);
    }

    setCategory(category) {
        if (category == "All") {
            this.previousSection = this.marketplaceProductSections.Products;
            for (var i = 0; i < (this.expanded.length - 1); i++) this.expanded[i] = false;
        }
        this.filterBy[2].chk = true;
        this.filterBy[2].val = category;
        this.filterBy[3].chk = false;
        this.filterBy[3].val = null;
        this.filterBy[4].chk = false;
        this.filterBy[5].chk = false;
        this.previousSection = this.marketplaceProductSections.ProductsCategory;
        this.setVisibleSections(false, false, true, false, false, false, true, false, false);
    }

    setVisibleSections(showPopUpDetails, showPopUpAddedCart, showLandingPage, showProductSectionLanding, showShoppingCartPage, showOrdersPage, showProductSectionFiltered, showPopUpBackground, showCheckoutMessage) {
        this.pscs.pointStoreVisibleContent.showLandingPage = showLandingPage;
        this.pscs.pointStoreVisibleContent.showProductSectionLanding = showProductSectionLanding;
        this.pscs.pointStoreVisibleContent.showProductSectionFiltered = showProductSectionFiltered;
        this.pscs.pointStoreVisibleContent.showShoppingCartPage = showShoppingCartPage;
        this.pscs.pointStoreVisibleContent.showPopUpAddedCart = showPopUpAddedCart;
        this.pscs.pointStoreVisibleContent.showPopUpDetails = showPopUpDetails;
        this.pscs.pointStoreVisibleContent.showOrdersPage = showOrdersPage;
        this.pscs.pointStoreVisibleContent.showPopUpBackground = showPopUpBackground;
        this.pscs.pointStoreVisibleContent.showCheckoutMessage = showCheckoutMessage;
    }

    setBestSeller() {
        this.filterBy[5].chk = true;
        this.filterBy[4].chk = false;
        this.filterBy[3].chk = false;
        this.filterBy[3].val = null;
        this.filterBy[2].chk = false;
        this.filterBy[2].val = null;
        this.previousSection = this.marketplaceProductSections.BestSellers;
        this.setVisibleSections(false, false, true, false, false, false, true, false, false);
    }

    changeTemplate(){
        if (this.filterMatchProduct !== '') {
            this.pscs.pointStoreVisibleContent.showLandingPage = true;
            this.pscs.pointStoreVisibleContent.showProductSectionFiltered = true;
            this.pscs.pointStoreVisibleContent.showProductSectionLanding = false;
            this.pscs.pointStoreVisibleContent.showShoppingCartPage = false;
            this.pscs.pointStoreVisibleContent.showOrdersPage = false;
        }
    }

    filterByProductProperties(items) {
        let filteredProducts = [];

        if (this.filterMatchProduct !== '') {
            this.currentFilter = this.filterMatchProduct;
        }

        if (items != null) {
            items.forEach((item) => {
                if (this.shoppingCartService.filterProducts(item, this.filterMatchProduct, this.filterBy)) {
                    filteredProducts.push(item);
                }
            });
            this.pscs.pointStoreProductFiltered = filteredProducts;
        }

        switch (this.sortBy) {
            case "Price":
            default:
                filteredProducts.sort((a, b) => {
                    let priceA: any = 0;
                    let priceB: any = 0;
                    if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
                        let variationA = a.VariationsData.reduce((prev, curr) => {
                            let variationPriceA = prev.VariationPrice;
                            let variationPriceB = curr.VariationPrice;
                            if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                                if (prev.VariationOnSale) {
                                    variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                                } else
                                    variationPriceA = prev.VariationPrice;
                                if (curr.VariationOnSale) {
                                    variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                                } else
                                    variationPriceB = curr.VariationPrice;
                            }
                            return variationPriceA < variationPriceB ? prev : curr
                        });
                        priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
                    }
                    else {
                        priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
                    }

                    if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
                        let variationB = b.VariationsData.reduce((prev, curr) => {
                            let variationPriceA = prev.VariationPrice;
                            let variationPriceB = curr.VariationPrice;
                            if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                                if (prev.VariationOnSale) {
                                    variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                                } else
                                    variationPriceA = prev.VariationPrice;
                                if (curr.VariationOnSale) {
                                    variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                                } else
                                    variationPriceB = curr.VariationPrice;
                            }
                            return variationPriceA < variationPriceB ? prev : curr
                        });
                        priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
                    }
                    else {
                        priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
                    }

                    return parseFloat(priceA) - parseFloat(priceB);
                });
                break;
            case "-Price":
                filteredProducts.sort((a, b) => {
                    let priceA: any = 0;
                    let priceB: any = 0;
                    if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
                        let variationA = a.VariationsData.reduce((prev, curr) => {
                            let variationPriceA = prev.VariationPrice;
                            let variationPriceB = curr.VariationPrice;
                            if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                                if (prev.VariationOnSale) {
                                    variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                                } else
                                    variationPriceA = prev.VariationPrice;
                                if (curr.VariationOnSale) {
                                    variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                                } else
                                    variationPriceB = curr.VariationPrice;
                            }
                            return variationPriceA < variationPriceB ? prev : curr
                        });
                        priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
                    }
                    else {
                        priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
                    }

                    if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
                        let variationB = b.VariationsData.reduce((prev, curr) => {
                            let variationPriceA = prev.VariationPrice;
                            let variationPriceB = curr.VariationPrice;
                            if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                                if (prev.VariationOnSale) {
                                    variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                                } else
                                    variationPriceA = prev.VariationPrice;
                                if (curr.VariationOnSale) {
                                    variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                                } else
                                    variationPriceB = curr.VariationPrice;
                            }
                            return variationPriceA < variationPriceB ? prev : curr
                        });
                        priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
                    }
                    else {
                        priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
                    }

                    return parseFloat(priceB) - parseFloat(priceA);
                });
                break;
            case "Title":
                filteredProducts.sort((a, b) => a.Title.localeCompare(b.Title));
                break;
            case "-Title":
                filteredProducts.sort((a, b) => b.Title.localeCompare(a.Title));
                break;
        }

        return filteredProducts;
    }

    hasManyProductsByFilter(category): any {
        return this.shoppingCartService.countDisplayCategoriesBySearch(category);
    }

    showSubCategories(index) {
        let i = 0;
        this.subCategoriesFilterChecked = [];
        if (this.expanded[index]) {
            this.expanded[index] = false;
        } else {
            for (i; i < (this.expanded.length); i++) {
                this.expanded[i] = false;
            }
            this.expanded[index] = true;
        }
    }

    hovered(hovering) {
        setTimeout(() => {
            if (hovering.objHovered == true) {
                hovering.tooltipOpened = true;
            }
        }, 0);
    }

    setSubCategory(subcategory, category, backToPreviousState) {
        if (!backToPreviousState) {
            var idx = this.subCategoriesFilterChecked.indexOf(subcategory);
            if (idx > -1) this.subCategoriesFilterChecked.splice(idx, 1);
            else this.subCategoriesFilterChecked.push(subcategory);
        }
        this.filterBy[4].chk = false;
        this.filterBy[5].chk = false;
        this.filterBy[3].chk = true;
        this.filterBy[3].val = this.subCategoriesFilterChecked;
        this.filterBy[2].chk = false;
        this.filterBy[2].val = category;
        this.previousSection = this.marketplaceProductSections.ProductsSubcategory;
        this.setVisibleSections(false, false, true, false, false, false, true, false, false);
    }

    setWishlist() {
        this.filterBy[4].chk = true;
        this.filterBy[5].chk = false;
        this.filterBy[3].chk = false;
        this.filterBy[3].val = null;
        this.filterBy[2].chk = false;
        this.filterBy[2].val = null;
        this.previousSection = this.marketplaceProductSections.Wishlist;
        this.setVisibleSections(false, false, true, false, false, false, true, false, false);
    }

    async goToOrders() {
        this.cleanInput();
        this.pscs.shoppingCartShowLoader = true;
        await this.pointStoreProductOrderService.LoadPointStoreProductHistoryOrders();
        this.pscs.shoppingCartShowLoader = false;
        $(".linee").hide();
        this.previousSection = this.marketplaceProductSections.Orders;
        this.setVisibleSections(false, false, false, false, false, true, false, false, false);
    }

    cleanInput() {
        this.filterMatchProduct = '';
    }

    onCustomFilterChange() {
        if (this.pspos.previousFilter == null || this.pspos.previousFilter != this.pspos.pointStoreProductAgentOrderFilter.searchOrder) {
            this.pspos.previousFilter = this.pspos.pointStoreProductAgentOrderFilter.searchOrder;
            this.pspos.historyOrders.forEach((o) => {
                o.expanded = false;
            });
        }
    }

    cleanInputOrders() {
        this.pspos.pointStoreProductAgentOrderFilter.searchOrder = '';
    }

    async goToCart() {
        this.filterMatchProduct = '';
        $(".linee").show();
        this.pscs.pointStoreVisibleContent.showPopUpAddedCart = false;
        this.highlightCartItem = false;
        this.setCartDrawerVisible();
        this.setVisibleSections(false, false, false, false, true, false, false, false, false);
    }

    getCurrentShoppingCart(): any {
        return this.shoppingCartService.getCurrentCartQuantity();
    }

    close() { }

    closePopUp() {
        this.pscs.pointStoreVisibleContent.showPopUpAddedCart = false;
        this.setCartDrawerVisible();
        this.pscs.pointStoreVisibleContent.showPopUpBackground = false;
    }

    //should I implement await here?
    deleteItemFromCart(product) {
        this.highlightCartItem = false;
        this.pscs.shoppingCartShowLoader = true;
        this.shoppingCartService.deleteItemFromCart(product)
            .then((result) => {
                if (this.pscs.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.ProductID; }) > -1) {
                    this.shoppingCartService.getCarouselItems();
                }
                if (this.pscs.pointStoreDetailedViewProduct != null) {
                    let currentProductUpdated = this.pscs.pointStoreProducts.find(p => p.PointStoreProductID == this.pscs.pointStoreDetailedViewProduct.PointStoreProductID);
                    if (currentProductUpdated != null) {
                        this.pscs.pointStoreDetailedViewProduct.Quantity = currentProductUpdated.Quantity;
                    }
                }
                this.pscs.shoppingCartShowLoader = false;
            });
    }

    getProductImage(cartItem) {
        if (cartItem != null && this.pscs.pointStoreProducts != null) {
            if (cartItem.ProductImageID != null && cartItem.ProductImageID > 0) {
                if (cartItem.Variation != null && cartItem.Variation > 0 && cartItem.VariationImgID != null && cartItem.VariationImgID > 0) {
                    return '../Admin/ImageResizer.aspx?imgid=' + cartItem.VariationImgID + '&w=auto&h=200';
                } else
                    return '../Admin/ImageResizer.aspx?imgid=' + cartItem.ProductImageID + '&w=auto&h=200';
            } else
                return '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80';
        }
    }

    getVariationName(productID, variationID) {
        if (this.pscs.pointStoreProducts != null) {
            let product = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == productID; });
            if (product != null && product.HasProductVariations) {
                let match = product.VariationsData.find((v) => { return v.PointStoreProductVariationID == variationID; });
                return match == null ? '' : (match.VariationName || '');
            }
        }
    }

    calculateCartTotal() {
        return this.shoppingCartService.getCartTotal();
    }

    sortProducts() {
        this.sortBy = this.shoppingCartService.sortProductOrder(this.selected);
    }

    showProductDetail(product) {
        this.cleanInput();
        this.pscs.pointStoreDetailedViewProduct = product;
        this.productQuantity = 1;
        this.isVariationSelected = true;
        this.selectedVariation = null;
        this.setVisibleSections(true, false, true, false, false, false, false, false, false);
        if (!product.HasMultipleImages)
            this.sliderEventHandlerCount = 0;
        setTimeout(() => {
            this.setSlider();
        }, 100);
    }

    getImagesCount(product) {
        let count = 0;
        if (product.MultipleImagesData != null && product.MultipleImagesData.length > 1) {
            let mainImages = product.MultipleImagesData.filter((i) => { return i.PointStoreProductVariationID == null || i.PointStoreProductVariationID == 0; });
            count = mainImages != null ? mainImages.length : 0;

            if (product.VariationsData != null && product.VariationsData.length > 0) {
                let variationImages = product.VariationsData.map((v) => {
                    if (v.Active == null || v.Active)
                        return v.PointStoreProductVariationID;
                });
                product.MultipleImagesData.forEach((currentValue, index, array) => {
                    if (variationImages.includes(currentValue.PointStoreProductVariationID))
                        count++;
                });
            }
            return count - 1;
        } else {
            return 1
        }
    }

    isCurrentSale(item: any): boolean {
        if (typeof item !== 'undefined' && item != null) {
            return this.shoppingCartService.filterCollectionsByType(item, 1);
        }

        return false;
    }

    isFeatured(item: any): boolean {
        if (typeof item !== 'undefined' && item != null) {
            return this.shoppingCartService.filterCollectionsByType(item, 2);
        }

        return false;
    }

    getVariationPrice(product) {
        this.initialVariationPrice = product.VariationsData.reduce((prev, curr) => {
            let prevValue = prev.VariationPrice;
            let currValue = curr.VariationPrice;
            if (prev.VariationOnSale)
                prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
            if (curr.VariationOnSale)
                currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
            return prevValue < currValue ? prev : curr;
        });
        return this.initialVariationPrice.VariationPrice;
    }

    checkSaleVariationPrice(product) {
        this.saleVariationFlag = false;
        product.VariationsData.forEach((variation) => {
            if (variation.VariationPrice == this.initialVariationPrice.VariationPrice && variation.VariationOnSale)
                this.saleVariationFlag = true;
        });
        if (this.saleVariationFlag) {
            return Math.ceil(this.initialVariationPrice.VariationPrice - (this.initialVariationPrice.VariationPrice * product.Sale / 100));
        }
    }

    getVariationCount(variations) {
        if (variations != null) {
            let variationCount = 0;
            variations.forEach((variation) => {
                if (variation.Active)
                    variationCount++;
            });
            return variationCount;
        }
    }

    isOutOfStock(product): any {
        if (product != null) {
            if (product.HasProductVariations) {
                let selectedVariation = product.VariationsData.find((v) => { return v.PointStoreProductVariationID == this.selectedVariation; });
                if (selectedVariation != null && (selectedVariation.VariationQuantity == 0 || selectedVariation.VariationQuantity < 0))
                    return true;
            } else {
                return product.Quantity == 0 || product.Quantity < 0;
            }
        } else
            return false;
    }

    isSelectedProductOnSale(product): any {
        if (product != null) {
            if (product.Sale && this.isCurrentSale(product)) {
                if (product.HasProductVariations) {
                    let selectedVariation = product.VariationsData.find((v) => { return v.PointStoreProductVariationID == this.selectedVariation; });
                    if (selectedVariation != null)
                        return selectedVariation.VariationOnSale;
                } else
                    return true;
            } else
                return false;
        }
    }

    getPriceToDisplay(product) {
        if (product != null) {
            if (product.HasProductVariations) {
                if (product.HasVariationPrices) {
                    if (this.selectedVariation != null && this.selectedVariation > 0) {
                        let selectedVariation = product.VariationsData.find((v) => { return v.PointStoreProductVariationID == this.selectedVariation; });
                        if (selectedVariation != null)
                            return selectedVariation.VariationPrice;
                    } else {
                        let initialVariationPrice = product.VariationsData.reduce((prev, curr) => {
                            return prev.VariationPrice < curr.VariationPrice ? prev : curr;
                        });
                        return initialVariationPrice.VariationPrice;
                    }
                } else {
                    return product.Price;
                }
            }
            return product.Price;
        }
    }

    getSalePrice(product) {
        if (product != null) {
            if (product.HasProductVariations) {
                if (product.HasVariationPrices) {
                    if (this.selectedVariation != null && this.selectedVariation > 0) {
                        let selectedVariation = product.VariationsData.find((v) => { return v.PointStoreProductVariationID == this.selectedVariation; });
                        return Math.ceil(selectedVariation.VariationPrice - (selectedVariation.VariationPrice * product.Sale / 100));
                    } else {
                        let initialVariationPrice = product.VariationsData.reduce((prev, curr) => {
                            return prev.VariationPrice < curr.VariationPrice ? prev : curr;
                        });
                        return Math.ceil(initialVariationPrice.VariationPrice - (initialVariationPrice.VariationPrice * product.Sale / 100));
                    }
                } else {
                    return Math.ceil(product.Price - (product.Price * product.Sale / 100));
                }
            }
            return Math.ceil(product.Price - (product.Price * product.Sale / 100))
        }
    }

    newVariationSelected(product) {
        this.productQuantity = 1;
        this.selectedVariationObj = product.VariationsData?.find(variation => variation.PointStoreProductVariationID === Number(this.selectedVariation));
        this.productQuantity = 1;
        this.previousSelectedQty = this.productQuantity;
        let inputs: any = document.getElementsByClassName('ProductQuantity');
        inputs[this.carouselIndex].value = this.previousSelectedQty;
    }

    checkQuantity(product) {
        if (this.previousSection === this.marketplaceProductSections.Home)
            this.pscs.pointStoreDetailedViewProduct = product;
        if (product.HasProductVariations && this.selectedVariation == null) {
            this.productQuantity = 1;
            return;
        }
        if (!(Number.isInteger(this.productQuantity) && this.productQuantity > 0))
            this.productQuantity = 1;
        if (product.HasProductVariations && this.selectedVariation != null && this.selectedVariation > 0) {
            let variationData = product.VariationsData.find((v) => { return v.PointStoreProductVariationID == this.selectedVariation; });
            if (this.productQuantity > variationData.VariationQuantity && variationData.VariationQuantity > 0)
                this.productQuantity = variationData.VariationQuantity;
        } else {
            if (this.productQuantity > this.pscs.pointStoreDetailedViewProduct.Quantity && this.pscs.pointStoreDetailedViewProduct.Quantity > 0)
                this.productQuantity = this.pscs.pointStoreDetailedViewProduct.Quantity;
        }
    }

    getText(isRemove) {
        if (isRemove)
            return this.getLocalizationString("Remove_Wishlist", "Remove From Wishlist");
        else
            return this.getLocalizationString("Add_to_Wishlist", "Add to Wishlist");
    }

    backToBrowse() {
        switch (this.previousSection) {
            case this.marketplaceProductSections.Home:
                this.goToHome();
                break;
            case this.marketplaceProductSections.BestSellers:
                this.setBestSeller();
                break;
            case this.marketplaceProductSections.Products:
                this.setCategory('All');
                break;
            case this.marketplaceProductSections.Wishlist:
                this.setWishlist();
                break;
            case this.marketplaceProductSections.Orders:
                this.goToOrders();
                break;
            case this.marketplaceProductSections.ProductsCategory:
                this.setCategory(this.filterBy[2].val);
                break;
            case this.marketplaceProductSections.ProductsSubcategory:
                this.setSubCategory(null, this.filterBy[2].val, true);
                break;
        }
        if (this.previousSection != this.marketplaceProductSections.Home)
            this.filterMatchProduct = this.currentFilter;
    }

    removeFromWishlist(product) {
        this.shoppingCartService.removeWishlistItem(product);

        if (this.previousSection === this.marketplaceProductSections.Home)
            this.pscs.pointStoreDetailedViewProduct = product;
        let productIndex = this.pscs.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.PointStoreProductID; });
        if (productIndex > -1)
            this.pscs.pointStoreProductCarouselItems[productIndex].isInWhisList = false;

        this.pscs.pointStoreDetailedViewProduct.isInWhisList = false;
    }

    addToWishlistProduct(product) {
        this.shoppingCartService.addWishlistItem(product);

        if (this.previousSection === this.marketplaceProductSections.Home)
            this.pscs.pointStoreDetailedViewProduct = product;
        let productIndex = this.pscs.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.PointStoreProductID; });
        if (productIndex > -1)
            this.pscs.pointStoreProductCarouselItems[productIndex].isInWhisList = true;

        this.pscs.pointStoreDetailedViewProduct.isInWhisList = true;
    }

    getHoverText(product) {
        if (product != null && product.isLocked)
            return this.getLocalizationString("Locked_by_Attributes", "You need to satisfy this item’s attribute requirements to add it to cart");
        else if (product != null && product.Quantity <= 0)
            return this.getLocalizationString("Temp_Out_Of_Stock", "Item is currently out of stock");
        else
            return "";
    }

    async addCartProduct(product, quantity) {
        if (product.HasProductVariations && (this.selectedVariation == null || this.selectedVariation < 1)) {
            this.isVariationSelected = false;
            return;
        } else {
            this.isVariationSelected = true;
        }
        if (!(this.pscs.pointStoreCart.pointStoreProducts.findIndex((p) => { return p.ProductID === product.PointStoreProductID; }) > -1)) {
            this.highlightCartItem = true;
        }

        this.pscs.shoppingCartShowLoader = true;
        //check session cart
        await this.shoppingCartService.getSessionCart();

        if (!this.checkAvailityToAddItemsToCart(product, quantity, this.selectedVariation)) {
            this.pscs.shoppingCartShowLoader = false;
            return;
        }

        this.shoppingCartService.addProductsToCart(product, quantity, this.selectedVariation).then((result: any) => {
            if (result) {
                if (this.pscs.pointStoreProductCarouselItems.findIndex((c) => { return c.PointStoreProductID == product.PointStoreProductID; }) > -1) {
                    this.shoppingCartService.getCarouselItems();
                }
                if (!this.pscs.pointStoreVisibleContent.showProductSectionLanding && !this.pscs.pointStoreVisibleContent.showOrdersPage) {
                    this.pscs.pointStoreDetailedViewProduct.Quantity = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == this.pscs.pointStoreDetailedViewProduct.PointStoreProductID; }).Quantity;
                }
                this.timerFunction();
                this.pscs.shoppingCartShowLoader = false;
                this.lastAdded = product;
                this.productQuantity = 1;
                this.previousSelectedQty = this.productQuantity;
                this.isVariationSelected = true;
                this.pscs.pointStoreVisibleContent.showPopUpAddedCart = true;
                this.setCartDrawerVisible();
                window.dispatchEvent(new Event('resize'));
            } else {
                this.pscs.shoppingCartShowLoader = false;
            }
        });
    }

    timerFunction() {
        this.drawerTimeOut = setTimeout(() => {
            if ($('#cart-drawer:hover').length == 0 && this.pscs.pointStoreVisibleContent.showPopUpAddedCart) {
                this.pscs.pointStoreVisibleContent.showPopUpAddedCart = false;
                this.setCartDrawerVisible();
                this.highlightCartItem = false;
            } else if (this.pscs.pointStoreVisibleContent.showPopUpAddedCart) {
                this.timerFunction();
            }
        }, 20000);
    }

    getLockedProductAttributeCategory(product) {
        let attributeCategoryLabel = '';
        let gropuedAttributes = product.PointStoreProductAllAssignments.attr.reduce((groupedObject, attribute) => {
            if (!groupedObject[attribute.AgentAttributeID]) {
                groupedObject[attribute.AgentAttributeID] = [];
            }
            groupedObject[attribute.AgentAttributeID].push(attribute);

            return groupedObject;
        }, {});

        for (let key in gropuedAttributes) {
            var attributeCategory = this.shoppingCartService.shoppingCartObj.currentUserAllAttributes.find((attr) => { return parseInt(attr.AgentAttributeID) == parseInt(key); });
            attributeCategoryLabel = attributeCategory.AttributeName;
        }
        return attributeCategoryLabel;
    }

    getLockedProductAttributeList(product) {
        let attrNamesLabel = '';
        let attrNames = [];
        let gropuedAttributes = product.PointStoreProductAllAssignments.attr.reduce((groupedObject, attribute) => {
            if (!groupedObject[attribute.AgentAttributeID]) {
                groupedObject[attribute.AgentAttributeID] = [];
            }
            groupedObject[attribute.AgentAttributeID].push(attribute);

            return groupedObject;
        }, {});

        for (let key in gropuedAttributes) {
            var attributeCategory = this.shoppingCartService.shoppingCartObj.currentUserAllAttributes.find((attr) => { return parseInt(attr.AgentAttributeID) == parseInt(key); });
            gropuedAttributes[key].filter((attr) => {
                attrNames.push(attr.AttributeValueName)
            });
            attrNamesLabel += attrNames.join(", ");
            attrNames = [];
        }
        return attrNamesLabel;
    }

    getTitle(d1, d2) { }

    setSlider() {
        if (this.pscs.pointStoreDetailedViewProduct != null && this.pscs.pointStoreDetailedViewProduct.HasMultipleImages && this.pscs.pointStoreDetailedViewProduct.MultipleImagesData.length > 0) {
            let thumbnails = document.getElementsByClassName('thumbnail');
            for (var i = 0; i < thumbnails.length; i++) {
                thumbnails[i].classList.remove('active');
            }
            thumbnails[0].classList.add('active');
            (<HTMLImageElement>document.getElementById('featured')).src = (<HTMLImageElement>thumbnails[0]).src;
            let chevrons = document.getElementsByClassName('image-chevrons');
            let activeImages = document.getElementsByClassName('active');

            if (this.sliderEventHandlerCount < 1) {
                this.sliderEventHandlerCount++;
                for (let j = 0; j < chevrons.length; j++) {
                    chevrons[j].addEventListener('click', function (event) {
                        let activeImage = null;
                        for (let i = 0; i < thumbnails.length; i++) {
                            if (thumbnails[i].classList.contains('active')) {
                                activeImage = thumbnails[i];
                                break;
                            }
                        }
                        let imgIndex = Array.prototype.indexOf.call(thumbnails, activeImage);
                        activeImage.classList.remove('active');

                        if (this.classList.contains('right-chevron')) {
                            if ((imgIndex + 1) >= thumbnails.length) {
                                let nextImage = thumbnails[0];
                                nextImage.classList.add('active');
                                (<HTMLImageElement>document.getElementById('featured')).src = (<HTMLImageElement>nextImage).src;
                            } else {
                                var nextImage = thumbnails[imgIndex + 1];
                                nextImage.classList.add('active');
                                (<HTMLImageElement>document.getElementById('featured')).src = (<HTMLImageElement>nextImage).src;
                            }
                        }

                        if (this.classList.contains('left-chevron')) {
                            if ((imgIndex - 1) < 0) {
                                let prevImage = thumbnails[thumbnails.length - 1];
                                prevImage.classList.add('active');
                                (<HTMLImageElement>document.getElementById('featured')).src = (<HTMLImageElement>prevImage).src;
                            } else {
                                var prevImage = thumbnails[imgIndex - 1];
                                prevImage.classList.add('active');
                                (<HTMLImageElement>document.getElementById('featured')).src = (<HTMLImageElement>prevImage).src;
                            }
                        }
                    })
                }
                let buttonRight = document.getElementById('slideRight');
                let buttonLeft = document.getElementById('slideLeft');

                buttonLeft.addEventListener('click', function () {
                    document.getElementById('slider').scrollLeft -= 180
                });

                buttonRight.addEventListener('click', function () {
                    document.getElementById('slider').scrollLeft += 180
                });
            }
            for (let i = 0; i < thumbnails.length; i++) {
                thumbnails[i].addEventListener('click', function () {
                    for (let i = 0; i < thumbnails.length; i++) {
                        thumbnails[i].classList.remove('active');
                    }
                    this.classList.add('active');
                    (<HTMLImageElement>document.getElementById('featured')).src = this.src;
                })
            }

            $('.variation_selector').on('change', () => {
                if (this.pscs.pointStoreDetailedViewProduct.VariationsData != null && this.pscs.pointStoreDetailedViewProduct.MultipleImagesData != null) {
                    let variationImageData = this.pscs.pointStoreDetailedViewProduct.MultipleImagesData.find((img) => { return img.PointStoreProductVariationID == this.selectedVariation; });
                    if (variationImageData != null) {
                        let thumbnailList = Array.from(thumbnails, function (th) { return (<HTMLImageElement>th).src; });
                        const variationThumbnail = thumbnailList.find(function (element) {
                            if (element.includes(variationImageData.PointStoreProductImageID)) {
                                return true;
                            }
                        });
                        if (variationThumbnail != null) {
                            for (let i = 0; i < thumbnails.length; i++) {
                                thumbnails[i].classList.remove('active');
                                if ((<HTMLImageElement>thumbnails[i]).src.includes(variationImageData.PointStoreProductImageID)) {
                                    thumbnails[i].classList.add('active');
                                    (<HTMLImageElement>document.getElementById('featured')).src = (<HTMLImageElement>thumbnails[i]).src;
                                }
                            }
                        }
                    }
                }
            });
        }
    }

    isSelected(image) {
        let currentSelectedImg = (<HTMLImageElement>document.getElementById('featured')).src;
        var initialPosition = currentSelectedImg.search("imgid");
        var finalPosition = currentSelectedImg.search("&w=");
        if (currentSelectedImg.substring(initialPosition + 6, finalPosition) == image.PointStoreProductImageID)
            return true;
    }

    setHomeSlider() {
        if (this.pscs.pointStoreProductCarouselItems.length > 0) {
            let featuredImages: any = document.getElementsByClassName('featured-home');
            if (this.pscs.pointStoreProductCarouselItems[0].MultipleImagesData != null && this.pscs.pointStoreProductCarouselItems[0].MultipleImagesData.length > 0) {
                this.pscs.pointStoreProductCarouselItems[0].MultipleImagesData.forEach((image) => {
                    this.homeSliderProductImages.push({ active: true, source: '../Admin/ImageResizer.aspx?imgid=' + image.PointStoreProductImageID + '&w=auto&h=388' })
                });
                if (featuredImages.length > 1) {
                    for (let i = 0; i < featuredImages.length; i++) {
                        featuredImages[i].src = this.homeSliderProductImages[0].source;
                    }
                } else {
                    let featuredImage: any = document.getElementsByClassName('featured-home');
                    featuredImage.src = this.homeSliderProductImages[0].source;
                }
            }
            let chevrons = document.getElementsByClassName('image-chevrons-home');
            for (let j = 0; j < chevrons.length; j++) {
                chevrons[j].addEventListener('click', (event: any) => {
                    if (featuredImages.length > 1) {
                        for (let i = 0; i < featuredImages.length; i++) {
                            featuredImages[i].src = this.homeSliderProductImages[0].source;
                        }
                    } else {
                        featuredImages.src = this.homeSliderProductImages[0].source;
                    }
                    if (event.currentTarget.classList.contains('right-chevron-home')) {
                        if ((this.homSlideImgIndex + 1) >= this.homeSliderProductImages.length) {
                            if (featuredImages.length > 1) {
                                for (let i = 0; i < featuredImages.length; i++) {
                                    featuredImages[i].src = this.homeSliderProductImages[0].source;
                                }
                            } else {
                                featuredImages.src = this.homeSliderProductImages[0].source;
                            }
                            this.homSlideImgIndex = 0;
                        } else {
                            if (featuredImages.length > 1) {
                                for (let i = 0; i < featuredImages.length; i++) {
                                    featuredImages[i].src = this.homeSliderProductImages[this.homSlideImgIndex + 1].source;
                                }
                            } else {
                                featuredImages.src = this.homeSliderProductImages[this.homSlideImgIndex + 1].source;
                            }
                            this.homSlideImgIndex++;
                        }
                    }

                    if (event.currentTarget.classList.contains('left-chevron-home')) {
                        if ((this.homSlideImgIndex - 1) < 0) {
                            if (featuredImages.length > 1) {
                                for (let i = 0; i < featuredImages.length; i++) {
                                    featuredImages[i].src = this.homeSliderProductImages[this.homeSliderProductImages.length - 1].source;
                                }
                            } else {
                                featuredImages.src = this.homeSliderProductImages[this.homeSliderProductImages.length - 1].source;
                            }
                            this.homSlideImgIndex = this.homeSliderProductImages.length - 1;
                        } else {
                            if (featuredImages.length > 1) {
                                for (let i = 0; i < featuredImages.length; i++) {
                                    featuredImages[i].src = this.homeSliderProductImages[this.homSlideImgIndex - 1].source;
                                }
                            } else {
                                featuredImages.src = this.homeSliderProductImages[this.homSlideImgIndex - 1].source;
                            }
                            this.homSlideImgIndex--;
                        }
                    }
                })
            }
            this.HomeProductSliderInitialized = true;
        } else {
            setTimeout(() => {
                this.setHomeSlider();
            }, 500);
        }
    }

    //Add a product to the cart by its ID.
    //  Useful for pages - such as AgentOrderHistory - which need to add an item to the cart but only have an ID.
    //  Added to pscs to expose it to other pages (such as AgentOrderHistory)
    addCartProductById(id, variation) {
        //Retrieve the item with the matching PointStoreProductID
        let matchedProduct = this.pscs.pointStoreProducts.filter((p) => {
            return p.PointStoreProductID == id;
        });

        //Verify if .filter() returned an array. If so, use the first item.
        if (Array.isArray(matchedProduct)) {
            matchedProduct = matchedProduct[0];
        }

        //Pass that object to the existing addCartProduct method.
        this.selectedVariation = variation;
        this.addCartProduct(matchedProduct, 1);
    }

    filterFeaturedProducts(items) {
        if (items.length > 4) {
            items.splice(4, items.length - 1);
        }
        return items;
    }

    checkAvailityToAddItemsToCart(product, quantity, variationId): boolean {
        let isAvaliable: boolean = true;
        let totalItems: number = 0;
        //it is a product with variation or not
        let productCart = variationId == null ?
            this.pscs.pointStoreCart.pointStoreProducts.find(x => x.ProductID == product.PointStoreProductID) :
            this.pscs.pointStoreCart.pointStoreProducts.find(x => x.ProductID == product.PointStoreProductID && x.Variation == variationId);

        //is the product in the cart?
        if (productCart) {
            totalItems = productCart.Quantity + Number(quantity);
            isAvaliable = totalItems > this.allowedQuantity ? false : true;

        } else {
            totalItems = quantity;
            isAvaliable = totalItems > this.allowedQuantity ? false : true;
        }

        //not available?
        if (!isAvaliable) {
            if (this.cvConfigurationService.isCxOne) {
                this.dialogService.showDialog(
                    this.getLocalizationString("Warning_Text", "Warning"),
                    this.getLocalizationString("Quantity_Added_Exceeds_Permitted_Limit", 'The quantity added exceeds the permitted limit.'),
                    1,
                    '',
                    this.getLocalizationString("Ok", "Ok"),
                    true,
                    () => { },
                    () => { }
                );
            } else {
                showErrorMessage(this.getLocalizationString("Quantity_Added_Exceeds_Permitted_Limit", 'The quantity added exceeds the permitted limit.'));
            }
        }
        return isAvaliable;
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    checkQtyInput($event: any, product) {
        if (this.previousSection === this.marketplaceProductSections.Home) {
            this.pscs.pointStoreDetailedViewProduct = product;
        }
        const inputValue = ($event?.target as HTMLInputElement)?.value ?? '';
        // Check if inputValue is empty
        if (inputValue === null || inputValue?.trim() === '') {
            this.productQuantity = 1; // Set default value to 1
            let inputs: any = document.getElementsByClassName('ProductQuantity');
            inputs[this.carouselIndex].value = this.productQuantity;
            return;
        }
        //Quantity changed by clicking + or - button
        if (Number.isInteger(inputValue) && Number(inputValue) > 0) {
            this.validateValue($event, product);
        } else {
            //Manually entered value
            setTimeout(() => {
                this.validateValue($event, product);
            }, 0);
        }
    }

    validateValue(event: KeyboardEvent, product) {
        let inputs: any = document.getElementsByClassName('ProductQuantity');
        let value = inputs[this.carouselIndex].value;
        //if value is not an integer:
        if (!(Number.isInteger(Number(value)) && Number(value) > 0)) {
            //if it is anything but the backspace then replace it with the previous valid value.
            if (event.keyCode != 8 && event.keyCode != 46) {
                this.productQuantity = this.previousSelectedQty;
                inputs[this.carouselIndex].value = this.productQuantity;
            } else {
                this.productQuantity = null;
                this.previousSelectedQty = null;
            }
            //the value is an integer greater than 0:
        } else {
            let maxStock = this.getProductStock(product);
            //if the value entered is greater than the available stock, set the maximum stock instead.
            if (Number(value) > maxStock) {
                this.productQuantity = maxStock;
                this.previousSelectedQty = maxStock;
                inputs[this.carouselIndex].value = maxStock;
            } else {
                this.productQuantity = value;
                this.previousSelectedQty = this.productQuantity;
                inputs[this.carouselIndex].value = this.previousSelectedQty;
            }
        }
    }


    getProductStock(product) {
        if (product.HasProductVariations) {
            if (this.selectedVariationObj != null) {
                let variationQty = null;
                product.VariationsData.forEach(variaton => {
                    if (variaton.PointStoreProductID == this.selectedVariationObj?.PointStoreProductID && variaton.PointStoreProductVariationID == this.selectedVariationObj?.PointStoreProductVariationID)
                        variationQty = variaton.VariationQuantity;
                });
                if (variationQty > 0 && variationQty != null)
                    return variationQty > 20 ? 20 : variationQty;
                else
                    return 20
            } else {
                return 20;
            }
        } else {
            if (product.Quantity > 0 && product.Quantity != null)
                return product.Quantity > 20 ? 20 : product.Quantity;
            else
                return 20
        }
    }

    getVariantValidationMessage(variationType: string) {
        const defaultText = `Please select a ${variationType} variation.`;
        const localizedMessage = this.getLocalizationString('Please_Select_A_Variation', defaultText);
        return localizedMessage.replaceAll("{0}", this.getLocalizationString(variationType, variationType));
      }
}
